export default __webpack_public_path__ + "static/media/bee.4a436364.png";